import WhatsNext from './WhatsNext';

export default WhatsNext;
